export const MODAL_LOGIN = 'MODAL_LOGIN';
export const LOGGED_IN_VIA_SIGNUP = 'SIGNUP';
export const LOGGED_IN_VIA_LOGIN = 'LOGIN';
export const RELOAD_COUNT = 'RELOAD_COUNT';
